var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('hr'),_c('p',{staticClass:"title-left m-b-0"},[_vm._v(" Variantes ")]),_c('view-component',{attrs:{"model_name":"article_variant","show_btn_create":false,"show_display":false,"prop_to_send_on_save":_vm.prop_to_send_on_save}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }